module.exports = __webpack_public_path__ + "static/media/icon_receipt02.0cff4d2c.png";